"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Compare_1 = require("../Utility/Compare");
class Arrays {
    /**
     * Returns the elements that are in left but not in right
     */
    static diff(left, right) {
        const leftLength = left.length;
        const rightLength = right.length;
        const rightMatches = [];
        const diff = [];
        // loop over all left values
        loop: for (let leftIndex = 0; leftIndex < leftLength; leftIndex++) {
            // loop over all right values
            for (let rightIndex = 0; rightIndex < rightLength; rightIndex++) {
                // right shouldn't already be matched and should be equal to left
                if (rightMatches.includes(rightIndex) || (0, Compare_1.default)(left[leftIndex], right[rightIndex]) === false) {
                    continue;
                }
                // remember the match we already found on the right side. Skip in this further searches
                rightMatches.push(rightIndex);
                continue loop;
            }
            // left value not found in right, add to diff
            diff.push(left[leftIndex]);
        }
        return diff;
    }
    /**
     * Deep compare two arrays, regardless of internal ordering
     */
    static deepEquals(left, right) {
        if (left === right) {
            return true;
        }
        if (left.length !== right.length) {
            return false;
        }
        return Arrays.diff(left, right).length === 0;
    }
}
exports.default = Arrays;
//# sourceMappingURL=Arrays.js.map